import { SiteUrls } from '@tableau/shared-urls';
import React from 'react';

import { PageHeaderDataConnectionButton } from '~src/datasource/dataConnection/components/spaces/header/PageHeaderDataConnectionButton';
import { DataSources } from '~src/datasource/resources/Datasources';
import { DevicePreviewButton } from '~src/spacesPlatform/components/breadcrumbs/DevicePreviewButton';
import { PageHeaderStyles } from '~src/spacesPlatform/components/layout/PageHeaderStyles';
import { VizViewerAppearanceMenu } from '~src/spacesPlatform/components/layout/VizViewerAppearanceMenu';
import { LayoutType } from '~src/spacesPlatform/state/LayoutType';
import { IViewBase } from '~src/views/models/IViewInfo';

export namespace VizViewerWidgetsBar {
  export interface Props {
    view: IViewBase; // set in VizSpaceProvider
    readonly siteUrls: SiteUrls;
    showDevicePreview: boolean; // set in VizSpaceProvider
    readonly handleDevicePreviewClick?: () => void;
    readonly layoutType: LayoutType;
  }
}

export const VizViewerWidgetsBar: React.SFC<VizViewerWidgetsBar.Props> = ({
  view,
  siteUrls,
  showDevicePreview,
  handleDevicePreviewClick,
  layoutType,
}) => {
  // TODO: Remove this when the viz viewer and viz previewer pre-resolve the intial view
  // Currently, the VizViewerCtrl and DevicePreviewModal do not resolve the initial view, so when the VizViewerWidgetsBar
  // first renders, the 'view' prop is null. This is in contrast with the other content controllers that pre-resolve
  // the relevant content in the router configuration. We should modify VizViewerCtrl and DevicePreviewModal to do this as
  // well, while considering that the user may be a guest and not have permission to make the getView call.
  if (!view) {
    return null;
  }

  const getDataSourceUrl = (id: string) => siteUrls.datasourceUrl(id);
  const getDataSources = () => DataSources.getByWorkbookId(view.workbook.id).then(list => list.items);
  const getVconnDataSourceUrl =  (id: string) => siteUrls.virtualConnectionGrantAccessUrl(id);
  const displayOnlyIcons = layoutType === 'tablet' || layoutType === 'mobile' || layoutType === 'laptop';

  return (
    <div className={PageHeaderStyles.VizViewerWidgetsBarStyle}>
      <VizViewerAppearanceMenu displayOnlyIcons={displayOnlyIcons} />

      { showDevicePreview &&
        <span className={PageHeaderStyles.DevicePreviewButtonContainer}>
          <DevicePreviewButton handleClick={handleDevicePreviewClick} displayOnlyIcons={displayOnlyIcons}/>
        </span> }

      <PageHeaderDataConnectionButton
        url={siteUrls.workbookDatasourcesUrl(view.workbook.id)}
        getDataSourceUrl={getDataSourceUrl}
        getDataSources={getDataSources}
        getVconnDataSourceUrl={getVconnDataSourceUrl}
        displayOnlyIcons={displayOnlyIcons}/>
    </div>
  );
};
